export default __webpack_public_path__ + "static/media/trash.1ef4f927.svg";